import { cleanQueryParams } from '@/utils/cleanQueryParams';

export const onRequestFulfilled = async (config: any) => {
  config.headers['accept-language'] = localStorage.getItem('locale') || 'ru';
  // Remove empty strings and undefined from query params
  config.params = cleanQueryParams(config.params);

  return config;
};
